import { React } from "react";
import ReactApexChart from "react-apexcharts";
import { Box } from "@material-ui/core";

import useStatRevenue from "../../../../hooks/useStatRevenue";
import moment from "moment";
import { useTranslate } from "react-admin";

const dateFormat = require("dateformat");
const CHART_HEIGHT = 240;

function BarChart({ periodType, fromDate, toDate }) {
  const { statRevenue, loading, error } = useStatRevenue(
    periodType,
    fromDate,
    toDate
  );
  const translate = useTranslate();
  if (loading) return null;
  if (error) return null;

  const [seriesMemberData, seriesWalkInData, xAxisData] =
    createDataCategoryStyle(statRevenue, periodType);

  let seriesTotalData = seriesMemberData.map((memberData, index) => {
    return memberData + seriesWalkInData[index];
    // else return [memberData[0], memberData[1] + seriesWalkInData[index][1]];
  });

  //put front and back data

  seriesMemberData.unshift(0);
  seriesMemberData.push(0);
  seriesWalkInData.unshift(0);
  seriesWalkInData.push(0);
  seriesTotalData.unshift(0);
  seriesTotalData.push(0);
  xAxisData.unshift("");
  xAxisData.push("");

  let series = [
    {
      name: translate("ra.text.bi.members"),
      data: seriesMemberData,
    },
    {
      name: translate("ra.text.bi.walkIn"),
      data: seriesWalkInData,
    },
    {
      name: translate("ra.text.bi.total"),
      data: seriesTotalData,
    },
  ];

  let xaxisOption = {
    type: "category",
    categories: xAxisData,

    tickPlacement: "between",
    // tickAmount: periodType === "Month" ? 12 : 7,
    labels: {
      show: true,
      formatter: function (value) {
        if (value) return value;
        else return "";
      },
    },
  };
  if (periodType === "All") {
    xaxisOption = {
      type: "category",
      categories: xAxisData,
      min: undefined,
      tickPlacement: "on",
      tickAmount: undefined,
      labels: {
        show: true,
        format: undefined,
        datetimeFormatter: undefined,
        formatter: function (value) {
          if (value) return "All";
          else return "";
        },
      },
    };
  }

  const options = {
    chart: {
      type: "bar",
      stacked: false,
      offsetX: 0,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },

    grid: {
      show: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        columnWidth: getPercentWidth(250, xAxisData.length, 20), //periodType === "Year" ? "10%" : "70%",
        horizontal: false,
      },
    },
    dataLabels: {
      enabled: false,
      style: {
        fontSize: "12px",
        colors: ["black"],
      },
    },
    xaxis: xaxisOption,
    yaxis: {
      title: {
        text: "Revenue",
      },
      labels: {
        formatter: (value) => {
          if (!value) return "";
          return value.toLocaleString();
        },
      },
      axisBorder: {
        show: true,

        offsetX: -1,
        offsetY: 0,
      },
    },
    legend: {
      show: true,
      position: "top",
      offsetY: 5,
      fontSize: "11px",
      markers: {
        width: 11,
        height: 11,
        strokeWidth: 0,
        radius: 12,
      },
      onItemClick: {
        toggleDataSeries: false,
      },
    },
    colors: ["#FA9917", "#2B3E6C", "#C4C4C4"],
    tooltip: {
      y: {
        formatter: (value) => {
          if (!value) return "";
          return value.toLocaleString();
        },
        title: {
          formatter: (seriesName) => seriesName,
        },
      },
    },
  };

  return (
    <Box>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={CHART_HEIGHT}
      />
    </Box>
  );
}

const getDateFormat = (periodType) => {
  if (periodType === "Day") return "DD MMM";
  else if (periodType === "Month") return "MMM";
  else if (periodType === "Year") return "YYYY";
  else return "DD MMM";
};

const createDataCategoryStyle = (statRevenue, periodType) => {
  let seriesWalkInData = [],
    seriesMemberData = [],
    xAxisData = [];
  statRevenue?.payload?.total_revenue?.forEach((element) => {
    if (!element.segment || !element || !element.segment.customerType) {
      //No data this day
      seriesWalkInData.push(0);
      seriesMemberData.push(0);
      let time = element.time?.split("T");
      if (periodType === "All") xAxisData.push("All");
      else xAxisData.push(moment(time[0]).format(getDateFormat(periodType)));
      return;
    }
    const guest = Object.values(element.segment.customerType).find(
      (value) => value.name === "Guest"
    );
    const member = Object.values(element.segment.customerType).find(
      (value) => value.name === "Member"
    );

    if (periodType === "All") {
      seriesWalkInData.push(guest.value);
      seriesMemberData.push(member.value);
      xAxisData.push("All");
    } else {
      seriesWalkInData.push(guest.value);
      seriesMemberData.push(member.value);

      if (!element.time) {
        seriesWalkInData.push(guest.value);
        seriesMemberData.push(member.value);
        xAxisData.push(dateFormat(Date(), "yyyy-mm-dd"));
        return;
      }
      let time = element.time.split("T");

      xAxisData.push(moment(time[0]).format(getDateFormat(periodType)));
    }
  });

  return [seriesMemberData, seriesWalkInData, xAxisData];
};

// const createDataDatetimeStyle = (statRevenue, periodType) => {
//   let seriesWalkInData = [],
//     seriesMemberData = [],
//     xAxisData = [];
//   statRevenue?.payload?.total_revenue?.forEach((element) => {
//     if (!element.segment || !element || !element.segment.customerType) {
//       //No data this day
//       seriesWalkInData.push([dateFormat(Date(), "yyyy-mm-dd"), 0]);
//       seriesMemberData.push([dateFormat(Date(), "yyyy-mm-dd"), 0]);
//       let time = element.time.split("T");

//       xAxisData.push(moment(time[0]).format("DD MMM YYYY"));
//       return;
//     }
//     const guest = Object.values(element.segment.customerType).find(
//       (value) => value.name === "Guest"
//     );
//     const member = Object.values(element.segment.customerType).find(
//       (value) => value.name === "Member"
//     );

//     if (periodType === "All") {
//       seriesWalkInData.push(guest.value);
//       seriesMemberData.push(member.value);
//       xAxisData.push("All");
//     } else {
//       if (element.time) {
//         seriesWalkInData.push([new Date(element.time).getTime(), guest.value]);
//         seriesMemberData.push([new Date(element.time).getTime(), member.value]);
//       }

//       if (!element.time) {
//         seriesWalkInData.push([dateFormat(Date(), "yyyy-mm-dd"), guest.value]);
//         seriesMemberData.push([dateFormat(Date(), "yyyy-mm-dd"), member.value]);
//         xAxisData.push(dateFormat(Date(), "yyyy-mm-dd"));
//         return;
//       }
//       let time = element.time.split("T");

//       xAxisData.push(moment(time[0]).format("DD MMM YYYY"));
//     }
//   });

//   return [seriesMemberData, seriesWalkInData, xAxisData];
// };

const getPercentWidth = (chartWidth, numData, pixel) => {
  const percentWidth = Math.round((pixel / (chartWidth / numData)) * 100);
  return `${percentWidth}%`;
};
export default BarChart;
